import { render, staticRenderFns } from "./TextCard.vue?vue&type=template&id=b8f389fe&scoped=true"
import script from "./TextCard.vue?vue&type=script&lang=js"
export * from "./TextCard.vue?vue&type=script&lang=js"
import style0 from "./TextCard.vue?vue&type=style&index=0&id=b8f389fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f389fe",
  null
  
)

export default component.exports